<template>
  <div class="share-progress-container">
    <div class="share-progress-content">
      <div class="title">{{ dialogContentData.title }}</div>
      <div class="content">{{ dialogContentData.content }}</div>
      <div class="btn flex-center" @click="handleClickBtn">{{ dialogContentData.button }}</div>
    </div>
    <div class="close-icon-content" @click="handleClose">
      <i class="iconfont iconx"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progress: {
      type: String,
      default: 'single',
    },
  },
  data() {
    return {}
  },
  mounted() {},
  components: {},
  watch: {},
  computed: {
    dialogContentData() {
      if (this.progress === 'single') {
        return {
          title: '已成功解锁资料',
          content: '请复制链接，前往浏览器下载',
          button: '复制链接',
        }
      } else if (this.progress === 'all') {
        return {
          title: '解锁全部资料',
          content: '点击前往资料页面查看',
          button: '前往查看',
        }
      } else if (this.progress === 'unlock') {
        return {
          title: '领取成功',
          content: '请复制链接，前往浏览器下载',
          button: '复制链接'
        }
      }
    },
  },
  methods: {
    handleClose() {
      this.$emit('handleClose')
    },
    handleClickBtn() {
      this.$emit('handleClickBtn')
    }
  },
}
</script>
<style scoped lang="scss">
.share-progress-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  background-color: rgba($color: #000000, $alpha: 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 190px;
  .share-progress-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: calc(100vw - 68px);
    height: 200px;
    background-image: url('https://logo.wondercv.com/banners/bAjjs5XqxHIAncp.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    padding-top: 36px;
    .title {
      font-size: 18px;
      color: #303546;
      line-height: 24px;
      font-weight: 500;
      margin-bottom: 12px;
    }
    .content {
      font-size: 15px;
      color: #303546;
      margin-bottom: 35px;
    }
    .btn {
      width: calc(100% - 48px);
      height: 46px;
      border-radius: 24px;
      background: linear-gradient(to right, #ff9f79, #ff6644);
      color: #fff;
      font-size: 18px;
    }
  }
  .close-icon-content {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 24px;
    height: 24px;
    border: 1px solid #fff;
    border-radius: 50%;
    color: #fff;
    margin-top: 32px;
    .iconfont {
      font-weight: bolder;
    }
  }
}
</style>
